import React, { useState } from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Sidebar from './Sidebar';
import Header from './Header';

const DashboardLayout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600"></div>
      </div>
    );
  }

  // Admins should NEVER accidentally land on the investor dashboard.
  // If the login flow lands them here (stale bundle, deep link, etc.)
  // bounce them straight to /admin. The AdminSidebar's "Back to Portal"
  // button adds ?preview=1 when the admin explicitly wants to see the
  // investor view — allow that through. The flag is ALSO mirrored into
  // sessionStorage on entry (below) because React Router drops query
  // params on every subsequent client-side navigation — without this,
  // clicking any sidebar link inside the preview immediately loses
  // ?preview=1 and bounces straight back to /admin (Header.js's "Exit
  // preview" badge clears the flag to leave deliberately).
  const queryPreview = new URLSearchParams(location.search).get('preview') === '1';
  if (queryPreview) {
    try { sessionStorage.setItem('admin_preview_mode', '1'); } catch { /* ignore */ }
  }
  let storedPreview = false;
  try { storedPreview = sessionStorage.getItem('admin_preview_mode') === '1'; } catch { /* ignore */ }
  const isPreview = queryPreview || storedPreview;
  if (user?.role === 'admin' && !isPreview) {
    return <Navigate to="/admin" replace />;
  }

  return (
    <div className="min-h-screen bg-[#F8F9FA]">
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
        mobileOpen={mobileNavOpen}
        onMobileClose={() => setMobileNavOpen(false)}
      />

      <div
        className={`transition-all duration-300 ml-0 ${
          sidebarCollapsed ? 'lg:ml-[70px]' : 'lg:ml-[260px]'
        }`}
      >
        <Header onMenuClick={() => setMobileNavOpen(true)} />

        <main className="p-4 md:p-8 lg:p-10">
          <div className="max-w-7xl mx-auto">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
